module.exports = __webpack_public_path__ + "static/media/CloseCircleIcon.294e96e8.png";